import styled from 'styled-components';
import { palette } from 'styled-tools';

import { Button, FocusRingVariants, fontWeight, FontWeights, minWidth } from '@calm-web/design-system';

import FullscreenBackground from '@/components/image/FullscreenBackground';
import GridWrapper from '@/components/ui/GridWrapper';

export const Wrapper = styled.section`
	color: ${palette('gray7')};
	margin: 0 auto;
	max-width: 1440px;
	padding: 140px 0;
	position: relative;
	text-align: center;
	width: 100%;
`;

export const Background = styled(FullscreenBackground)``;

export const ContentWrapper = styled(GridWrapper)`
	background: ${palette('white')};
	grid-gap: 0;
	padding: 32px;

	${minWidth('tablet')} {
		padding: 64px;
	}

	${minWidth('desktop')} {
		padding: 64px 164px;
	}
`;

export const Heading = styled.h2`
	${fontWeight(FontWeights.Regular)};
	margin-bottom: 40px;
`;

export const MobileBreak = styled.span`
	display: block;

	${minWidth('desktop')} {
		display: none;
	}
`;

export const BodyText = styled.h5`
	${fontWeight(FontWeights.Regular)};
	margin-bottom: 40px;
`;

export const CtaButton = styled(Button).attrs({
	focusRingVariant: FocusRingVariants.Dark,
})`
	margin: 0 auto;
`;
